<template>
    <div>
        <div class='footer-column-title'>
            Product
        </div>
        <div class='footer-column-links'>
            <div @click="onClickLink('product/soltuion')"><a class="footer-link">Solution</a></div>
            <div @click="onClickLink('product/value-props')"><a class="footer-link">Value Props</a></div>
            <div @click="onClickLink('product/use-cases')"><a class="footer-link">Use Cases</a></div>
        </div>
    </div>
</template>
<script>
export default {
    methods: {
        onClickLink(page, external = false) {
            if(external) {
                window.open(page, '_blank');
            } else {
                this.$router.push(`/${page}`);
            }
        }
    }
}
</script>